import { notification } from 'antd';
import React from 'react'
import { useAppSelector } from 'store'
import { useCopyToClipboard } from 'usehooks-ts';

const RefUser = () => {
    const { user } = useAppSelector((state) => state.app) as any
    const [copiedText, copy] = useCopyToClipboard();
    function getUrl(pathname: string) {
        let { hostname, protocol, port } = window.location;
        let portString = "";
        if (port !== "80" && port !== "443" && port !== "") {
            portString = ":" + port;
        }
        return protocol + "//" + hostname + portString + "/" + pathname;
    }

    const handleCopy = (text: string) => {
        console.log(text);

        copy(text)
            .then(() => {
                notification.success({
                    message: "Copied!",
                    duration: 5,
                });
            })
            .catch((error) => {
                console.error("Failed to copy!", error);
            });
    };

    function formatEmail(email: string) {
        const [localPart, domain] = email.split("@");
        const formattedLocalPart = localPart.charAt(0) + "***";
        const domainParts = domain.split(".");
        const formattedDomain =
            domainParts[0].charAt(0) + "***" + domainParts[0].slice(-1);
        return `${formattedLocalPart}@${formattedDomain}.${domainParts
            .slice(1)
            .join(".")}`;
    }
    return (
        <div className="max-w-[1280px]  mx-auto p-5">
            <div className='flex justify-between items-center'>

                <div className='mb-3 text-[#fff] font-[900] md:text-[40px] text-center'>
                    Giới thiệu nhiều người chơi mới <br /> để được ưu đãi nhiều hơn
                </div>
                <img className='w-[200px] md:w-[400px]' src="https://www.bitget.com/events/_next/static/media/banner-image.3295db34.png" />
            </div>
            <div className='text-[#fff] flex gap-3 mb-3 items-center text-[18px]'>
                <div>Mã giới thiệu: <span className='font-[900]'>{user?.code}</span> </div>
                <div
                    className="cursor-pointer"
                    onClick={() => handleCopy(user?.code)}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 text-[#fff]">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                    </svg>

                </div>
            </div>
            <div className='text-[#fff] flex gap-3 items-center text-[18px]'>
                <div>Link giới thiệu: <span className='font-[900]'>
                    {getUrl("register?r=" + user?.code)}</span> </div>
                <div
                    className="cursor-pointer"
                    onClick={() => handleCopy(getUrl("register?r=" + user?.code))}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 text-[#fff]">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                    </svg>

                </div>
            </div>
            <div className='my-4 '>
                <h3 className='text-[20px] text-[#fff] font-[700]'>Người đã giới thiệu</h3>

                <div className="relative overflow-x-auto my-4 ">
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" className="px-6 py-3">
                                    Email
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    Họ và tên
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    Số người giới thiệu
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    Ngày giới thiệu
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                user?.referredUsers?.map((i: any) => (
                                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                        <th
                                            scope="row"
                                            className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                                        >
                                            {formatEmail(i?.email)}
                                        </th>
                                        <td className="px-6 py-4">{i?.last_name}</td>
                                        <td className="px-6 py-4">{i?.referredUsers?.length || 0}</td>
                                        <td className="px-6 py-4">{new Date(i?.createdAt)?.toLocaleString()}</td>
                                    </tr>
                                ))
                            }


                        </tbody>
                    </table>
                </div>


            </div>
        </div>
    )
}

export default RefUser